<template lang="pug">
  at-ta.TagSymbol(:members="members", :at="setsInfo[currentSet].symbol", @at="atHandler", :allow-spaces="false", :name-key="setsInfo[currentSet].nameKey", :filterMatch="noFilter")
    template(v-if="currentSet === 'users'" v-slot:item="s")
      span(v-text="s.item.tagListName")

    g-tag-symbol(v-if="dataSets.length > 1", :dataSets="tailSets")
      slot
    slot(v-else)
</template>


<script>
import AtTa from 'vue-at/dist/vue-at-textarea';
import axios from 'axios';

export default {
  name: 'TagSymbol',
  components: { AtTa },
  props: {
    dataSets: {
      type: Array,
      default: () => ['users'],
    },
  },
  data: () => ({
    members: [],
    atSearch: null,
    setsInfo: {
      users: {
        symbol: '@',
        endpoint: 'UserRoleBusinessScope?load[]=User',
        nameKey: 'tagName',
      },
      orders: {
        symbol: '#',
        endpoint: [{ orderNumber: '3456' }, { orderNumber: '2202' }, { orderNumber:'1044' }], // Replace with API endpoint name
        nameKey: 'orderNumber',
      },
    },
  }),
  methods: {
    async atHandler(value) {
      if (this.atSearch === value) return;
      this.atSearch = value;

      if (value.length > 2) {
        let resp = await axios.get(`${this.setsInfo[this.currentSet].endpoint}`, { params: { where: [`x => x.User.Name.contains("${value}")`] }})
        this.members = this.getUniqueUsers((_.get(resp, 'data.data', [])).map(x => x.user));
      } else {
        this.members = []
      }
    },
    // Get unique users of a list of them, checking by id
    getUniqueUsers(listUsers) {
      const result = [];
      const map = new Map();
      for (const item of listUsers) {
        if(!map.has(item.id)){
            map.set(item.id, true);
            result.push(item);
        }
      }
      return result;
    },
    noFilter() {
      return true;
    },
  },
  computed: {
    currentSet() {
      const [cS, ...tS] = this.dataSets;
      return cS;
    },
    tailSets() {
      const [cS, ...tS] = this.dataSets;
      return tS;
    },
  },
}
</script>

